import { contentBase as contentBaseSchema } from './content';
import { z } from 'zod';
import { metadata } from './helpers';

export const accidentTypeContentSchema = z.object({
  metadata: metadata,
  data: z.object({
    title: z.string(),
    types: z.array(
      z.object({
        title: z.string(),
        content: z.string(),
        icon: z.string(),
      })
    ),
  }),
});

export const contentTypeAccidentTypeSchema = contentBaseSchema.extend({
  content: accidentTypeContentSchema,
});

export type ContentTypeAccidentTypeContentInput = z.infer<typeof contentTypeAccidentTypeSchema>;
